import React from 'react'
import { useTranslation } from 'react-i18next'
import Field from 'components/Shared/Fields'
import CampaignRequirements from '../CampaignRequirements'
import { UploadType } from 'services/api/uploads'
import { EditorContainer } from './styles'
import { fieldIdentifiers } from 'components/Shared/Comment'
import InputField from 'components/Shared/Fields'
import Divider from 'components/Shared/Divider'
import Text from 'particles/Text'
import MaskWrapper from 'components/Campaign/Editor/MaskWrapper'
import CampaignEditorInputFieldContainer from 'components/Shared/Permission/CampaignEditorInputFieldContainer'

const Editor: React.FC = () => {
    const [t] = useTranslation()

    return (
        <EditorContainer>
            <MaskWrapper>
                <Text scale="H4">{t('campaignEditor.completeSetup.pageTitle')}</Text>
                <Divider className="first-divider" />
                <div className="editor-form-field">
                    <CampaignEditorInputFieldContainer>
                        <Field.ImageUploadField
                            uploadContainerWidth="495px"
                            presetType={UploadType.CAMPAIGN}
                            maxFiles={10}
                            name="images"
                            title={t('campaignEditor.completeSetup.uploadCampaignBannerHeader')}
                            subtitle={t('campaignEditor.completeSetup.uploadCampaignBannerSubtext')}
                            isRequired
                            requiredHeight={750}
                            requiredWidth={1000}
                            dataTestId="test-campaign-banner-upload"
                            placeholder={t('placeholderText.dragDropFilesDimension')}
                            identifier={fieldIdentifiers.campaignBanner}
                        />

                        <InputField.TextAreaField
                            label={t('campaignEditor.completeSetup.enterCampaignDescriptionHeader')}
                            subtext={t('campaignEditor.completeSetup.enterCampaignDescriptionSubtext')}
                            dataTestId="test-campaign-description-input"
                            isRequired
                            width="495px"
                            name="description"
                            identifier={fieldIdentifiers.campaignDescription}
                        />
                    </CampaignEditorInputFieldContainer>

                    <Divider maxWidth="755px" />
                    <CampaignRequirements name="requirementsData" />
                </div>
            </MaskWrapper>
        </EditorContainer>
    )
}

export default Editor
